import React from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import '../styles/Blog.css';
import blogPosts from '../data/blogPosts';
import TalkExpertSection from '../components/TalkExpertSection';

export default function BlogDetail() {
  const { slug } = useParams();
  const postIndex = blogPosts.findIndex((b) => b.slug === slug);
  const post = blogPosts[postIndex];
  const navigate = useNavigate();

  // Find previous and next posts
  const prevPost = postIndex > 0 ? blogPosts[postIndex - 1] : null;
  const nextPost = postIndex < blogPosts.length - 1 ? blogPosts[postIndex + 1] : null;

  // Related posts (show 3 others, not current)
  const relatedPosts = blogPosts.filter((b, i) => i !== postIndex).slice(0, 3);

  // Determine nav button count for styling
  const navBtnCount = [prevPost, nextPost].filter(Boolean).length + 1; // +1 for Back to Blog
  const navRowClass =
    navBtnCount === 3
      ? 'blog-detail-nav-row blog-detail-nav-between'
      : 'blog-detail-nav-row blog-detail-nav-center-group';

  if (!post) {
    return (
      <div className="blog-detail-light-bg">
        <div className="blog-detail-card">
          <h2>Blog Not Found</h2>
          <Link to="/blog" className="back-to-blog">← Back to Blog</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="blog-detail-light-bg">
      <div className="blog-detail-card">
        <img src={post.image} alt={post.title} className="blog-detail-image" />
        <div className="blog-detail-category-row">
          <span className="blog-detail-category-chip">{post.category}</span>
          <span className="blog-detail-date">{post.date}</span>
        </div>
        <h1 className="blog-detail-title-main">{post.title}</h1>
        <div className="blog-detail-content-main">
          {post.content.split('\n').map((para, idx) => (
            <p key={idx}>{para}</p>
          ))}
        </div>
        <div className={navRowClass}>
          {prevPost && (
            <button className="blog-detail-nav-btn" onClick={() => navigate(`/blog/${prevPost.slug}`)}>
              ← Prev Post
            </button>
          )}
          <Link to="/blog" className="blog-detail-nav-btn blog-detail-nav-center">Back to Blog</Link>
          {nextPost && (
            <button className="blog-detail-nav-btn" onClick={() => navigate(`/blog/${nextPost.slug}`)}>
              Next Post →
            </button>
          )}
        </div>

        <TalkExpertSection />
        
        
        <div className="blog-detail-related-section">
          <h3>Related Posts</h3>
          <div className="blog-detail-related-grid">
            {relatedPosts.map((rel) => (
              <Link to={`/blog/${rel.slug}`} className="blog-detail-related-card" key={rel.slug}>
                <img src={rel.image} alt={rel.title} />
                <div className="blog-detail-related-info">
                  <span className="blog-detail-category-chip">{rel.category}</span>
                  <h4>{rel.title}</h4>
                  <p>{rel.excerpt}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
} 